
/* eslint-disable no-restricted-syntax */
import { Component } from 'vue-property-decorator';
import BridgesTemplate from '@/components/bridges/BridgesTemplate.vue';
import Graph from '@/components/Graphs';

@Component({
  components: {
    BridgesTemplate,
  },
})

export default class Map1 extends BridgesTemplate {
  availableBridges = 10;

  optimalNrOfBridges = 7;

  nrOfEdges = 15;

  nrOfVertices = 8;

  map = new Graph(this.nrOfVertices);

  // eslint-disable-next-line max-len
  edges = [[0, 1], [0, 2], [0, 3], [1, 2], [2, 3], [1, 4], [3, 6], [2, 4], [2, 5], [2, 6], [4, 5], [4, 7], [5, 7], [2, 7], [6, 7]];

  // eslint-disable-next-line max-len
  fields = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];

  initGraph():void {
    for (let i = 0; i < this.nrOfVertices; i += 1) {
      this.map.addVertex(i);
    }
    for (let i = 0; i < this.edges.length; i += 1) {
      this.map.addEdge(this.edges[i][0], this.edges[i][1]);
    }
  }
}
